"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyPremiumProfilePreselectionContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const CompanyPremiumProfilePreselectionContent = ({ productAmount, setSelectedProductAmount }) => {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-col justify-center m-m p-m align-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "text-center m-m", children: (0, jsx_runtime_1.jsx)("h2", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.company_premium_profile.subscribe_for" }) }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(elements_1.RadioGroup, { optionType: "button", defaultValue: productAmount, onChange: e => setSelectedProductAmount(e.target.value), options: Object.values(types_1.SubscriptionPeriods)
                        .filter(x => typeof x === 'number')
                        .map(subPeriod => ({
                        label: intl.formatMessage({ id: 'general.month.pluralized' }, { count: subPeriod }),
                        value: subPeriod,
                    })) }) })] }));
};
exports.CompanyPremiumProfilePreselectionContent = CompanyPremiumProfilePreselectionContent;
